import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
var clientId;
var sessionId;
let analytics;

if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
  gtag(
    "get",
    `${process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID}`,
    "client_id",
    (client) => {
      clientId = client;
    }
  );
  gtag(
    "get",
    `${process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID}`,
    "session_id",
    (session_id) => {
      sessionId = session_id;
    }
  );
}
export { analytics, clientId, sessionId };
